import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Briefcase, MapPin } from "lucide-react";

import { PageHero, Section } from "@/components/site/section";
import { jobsQuery } from "@/lib/site-queries";

export const Route = createFileRoute("/contact-us/jobs")({
  head: () => ({
    meta: [
      { title: "Job Listings | Argentinian.Soccer" },
      { name: "description", content: "Open editorial, video and product roles at Argentinian.Soccer." },
      { property: "og:title", content: "Job Listings | Argentinian.Soccer" },
      { property: "og:url", content: "/contact-us/jobs" },
    ],
    links: [{ rel: "canonical", href: "/contact-us/jobs" }],
  }),
  loader: ({ context }) => context.queryClient.ensureQueryData(jobsQuery()),
  component: JobsPage,
});

function JobsPage() {
  const { data } = useSuspenseQuery(jobsQuery());
  return (
    <>
      <PageHero eyebrow="Careers" title="Job Listings" />
      <Section>
        <div className="space-y-4">
          {data.map((job) => (
            <div key={job.id} className="rounded-lg border border-border bg-card p-6">
              <h2 className="font-display text-xl font-bold text-navy">{job.title}</h2>
              <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground">
                {job.location && <span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {job.location}</span>}
                {job.type && <span className="inline-flex items-center gap-1"><Briefcase className="h-3.5 w-3.5" /> {job.type}</span>}
              </div>
              {job.description && <p className="mt-3 text-sm text-muted-foreground">{job.description}</p>}
            </div>
          ))}
          {data.length === 0 && <p className="text-sm text-muted-foreground">No open roles right now — check back soon.</p>}
        </div>
      </Section>
    </>
  );
}
